import styled from 'styled-components';
import PlainArrow from '../../assets/images/plain-arrow-icon.svg';

interface PlainArrowIconProps {
  /** Icon height in `px`. Defaults to `10px`. */
  height?: string;

  /** Icon width in `px`. Defaults to `10px`. */
  width?: string;

  /** Icon fill colour. Defaults to `#F0645A` */
  fill?: string;

  /** Direction arrow is pointing. Defaults to `up`. */
  $point: 'up' | 'down' | 'left' | 'right';
}

const PlainArrowIcon = styled.span<PlainArrowIconProps>`
  ${({ $point = 'up', fill = '#F0645A', height = '10px', width = '10px' }) => `
    background-color: ${fill};
    display: inline-block;
    height: ${height};
    mask-image: url("${PlainArrow}");
    mask-position: center center;
    mask-repeat: no-repeat;
    mask-size: 100%;
    position: relative;
    transform: ${(() => {
      switch ($point) {
        case 'down':
          return 'rotate(180deg)';
        case 'left':
          return 'rotate(90deg)';
        case 'right':
          return 'rotate(-90deg)';
        case 'up':
        default:
          return 'rotate(0)';
      }
    })()};
    width: ${width};
  `}
`;

export default PlainArrowIcon;
